<template>
    <div class="table-container ">
        <div class="filter-container ml-2 mt-2">
                <validated-date-picker
                    format="DD-MM-YYYY"
                    :clearable="true"
                    v-model="calving_date"
                    label="Calving Date"
                    class="c-input-datepicker">
                </validated-date-picker>
        </div>
        <vue-table ref="table1" :fields="fields" :url="calvingListURL" :per-page="10" :show-search-box="false" :extra-params="{ calving_date: calving_date }">
        </vue-table>
    </div>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name: 'CalvingDetails',
    computed: {
        ...mapGetters(['currentUser']),
        calvingListURL () {
            const cowID = this.$route.params.id;

            return urls.cowDetailEdit.calvingInfo + '?id=' + cowID;
        }
    },

    data () {
        return {
            animal: 'cow',
            id: '',
            calving_date: '',
            fields: [
                {
                    name: 'calving_date',
                    title: 'Date',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-10r fs-lg-0'
                },
                {
                    name: 'abort_status',
                    title: 'Abortion Status',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-10r fs-lg-0'
                },
                {
                    name: 'male_calves_no',
                    title: 'No.of Male Calves',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0'
                },
                {
                    name: 'female_calves_no',
                    title: 'No.of Female Calves',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-15r fs-lg-0'
                },
                {
                    name: 'remarks',
                    title: 'Remarks',
                    titleClass: 'text-6 fs-lg-0 font-poppins-bold b-unset',
                    dataClass: 'text-2 bg-6 b-unset w-20r fs-lg-0'
                }
            ],
            loading: false
        };
    },

    mounted () {
        this.id = this.$route.params.id;
    }
};
</script>

<style scoped>
.table-container {
        background-color: #fff;
        border-radius: 12px;
        padding: 10px;
    }

    .filter-container {
        width: 200px;
    }
</style>
